import { ENVIRONMENT_VALUES } from './ENVIRONMENT_VALUES';
import type { EnvironmentValue } from '../types/EnvironmentValue';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Telehealth-specific environment variable key constants for convenient access</blockquote>
 * 
 * @example
 * ```typescript
 * import { TELEHEALTH_CONSTANTS } from '@shared/utils';
 * import { getEnvironmentValue } from '@shared/utils';
 * 
 * const ttl = await getEnvironmentValue(TELEHEALTH_CONSTANTS.JOIN_TICKET_TTL_SECONDS);
 * ```
 */
export const TELEHEALTH_CONSTANTS = {
  JOIN_TICKET_TTL_SECONDS: ENVIRONMENT_VALUES.TELEHEALTH.TELEHEALTH_JOIN_TICKET_TTL_SECONDS,
  SESSION_CREDENTIAL_TTL_SECONDS: ENVIRONMENT_VALUES.TELEHEALTH.TELEHEALTH_SESSION_CREDENTIAL_TTL_SECONDS,
  JOIN_TICKET_SIGNING_SECRET: ENVIRONMENT_VALUES.TELEHEALTH.TELEHEALTH_JOIN_TICKET_SIGNING_SECRET,
  DEFAULT_CLINICIAN_USER_ID: ENVIRONMENT_VALUES.TELEHEALTH.TELEHEALTH_DEFAULT_CLINICIAN_USER_ID,
} as const satisfies Record<string, EnvironmentValue>;
